<template lang="html">
  <v-text-field
    ref="input"
    v-model="internalValue"
    v-bind="$attrs"
    :label="internalLabel"
    :rules="internalRules"
    data-lpignore="true"
    autocomplete="off"
    v-on="$listeners"
  />
</template>

<script>
import helpers from '@/mixins/helpers'
import element from '@/mixins/element'

export default {
  mixins: [ helpers, element ],
  props: {
    value: String
  },
  data () {
    return {
      lazyValue: this.value,
      requiredRule: v => this.valueValid(v) || `${this.$attrs.label || 'This field'} is required`
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
    }
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>

</style>
